import { createBreadcrumbsApi } from 'piral-breadcrumbs';
import { PiralPlugin, storage } from 'piral-core';
import { createDashboardApi } from 'piral-dashboard';
import { createMenuApi } from 'piral-menu';
import { createNotificationsApi } from 'piral-notifications';
import { createLocaleApi, LocaleConfig, setupLocalizer } from 'piral-translate';

import { createKeycloakApi } from './keycloak-api';
import { createSipletApi } from './siplet-api';
import { createSnowfallApi } from './snowfall-api';
import { createFirefliesApi } from './fireflies-api';
import { translations } from './translations.codegen';

function setupLocalizable() {
  const locale = storage.getItem('locale');
  const config: LocaleConfig = {
    language: locale,
    messages: translations,
    fallback: (key, language) => {
      console.warn(`Translation for '${key}' in ${language.toUpperCase()} missing.`);
      const message = (config.messages['en'][key] as string) ?? key;
      return message;
    },
  };
  return setupLocalizer(config);
}

export function getPlugins(): PiralPlugin[] {
  return [
    createMenuApi({
      // defaultSettings gilt für alle Pilets, die keine expliziten MenuSettings haben
      defaultSettings: {
        type: 'sidebar',
      },
    }),
    createNotificationsApi(),
    createDashboardApi({
      defaultPreferences: {
        initialColumns: 2,
        initialRows: 2,
      },
    }),
    createLocaleApi(setupLocalizable()),
    createBreadcrumbsApi(),
    createSnowfallApi(),
    createFirefliesApi(),
    createKeycloakApi(),
    createSipletApi(),
  ];
}
